import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./errorModal.html";
const columns = [{
  label: 'Name',
  fieldName: 'name',
  hideDefaultActions: false,
  initialWidth: 350
}, {
  label: 'Developer Name',
  fieldName: 'developerName',
  hideDefaultActions: false,
  initialWidth: 250
}, {
  label: 'Type',
  fieldName: 'componentType',
  hideDefaultActions: false,
  initialWidth: 250
}, {
  label: 'Error',
  fieldName: 'message',
  hideDefaultActions: false,
  wrapText: true
}];
class ErrorModal extends LightningElement {
  constructor(...args) {
    super(...args);
    this.items = void 0;
    this.modalTitle = void 0;
    this.isModalOpen = void 0;
    this.migrateStatusData = void 0;
    this.columns = columns;
    this.closeModal = () => {
      this.isModalOpen = false;
    };
  }
}
_registerDecorators(ErrorModal, {
  publicProps: {
    items: {
      config: 0
    },
    modalTitle: {
      config: 0
    },
    isModalOpen: {
      config: 0
    },
    migrateStatusData: {
      config: 0
    }
  },
  fields: ["columns", "closeModal"]
});
export default _registerComponent(ErrorModal, {
  tmpl: _tmpl
});